// src/components/core/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import MobileNavbar from '../navbar/MobileNavbar';
import { useMediaQuery } from 'react-responsive';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Layout = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1024px)', // Adjust the breakpoint as needed
  });
  const hideNavbar = true; // temporarily hide navigation
  const containerBgClass = hideNavbar ? '' : 'bg-custom-blue';
  const contentMarginClass = hideNavbar ? '' : 'ml-56';

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {isDesktopOrLaptop ? (
        <div className={`flex ${containerBgClass} h-full`}>
          {/* Desktop Navbar (hidden) */}
          {!hideNavbar && <Navbar />}

          {/* Toast Notifications */}
          <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />

          {/* Main Content */}
          <div className={`flex-grow ${contentMarginClass} p-4 bg-gray-50 overflow-auto`}>
            <Outlet />
          </div>
        </div>
      ) : (
        <>
          {/* Mobile Navbar (hidden) */}
          {!hideNavbar && (
            <div className="mb-2">
              <MobileNavbar />
            </div>
          )}
          {/* Main Content */}
          <div className="pt-16 p-4 bg-gray-50 overflow-auto flex-1">
            <Outlet />
          </div>
        </>
      )}
    </div>
  );
};

export default Layout;
